export const AlertTypes = {
  SUCCESS: 'success',
  WARN: 'warning',
  INFO: 'info',
  ERROR: 'error'
}
